import { MarketingLayout } from '../../layouts/MarketingLayout';

const cookieTypes = [
  {
    name: 'Strictly necessary',
    desc: 'Required to operate the service — for example, authenticating you, remembering your session, and protecting against fraud. These cannot be disabled.',
  },
  {
    name: 'Functional',
    desc: 'Remember preferences such as your language and theme. Disabling these may degrade your experience but will not break core functionality.',
  },
  {
    name: 'Analytics',
    desc: 'Help us understand how members navigate Keskedo so we can improve it. We use aggregated, privacy-respecting analytics tooling.',
  },
  {
    name: 'Marketing',
    desc: 'Allow us to show you relevant Keskedo content on other sites. You can opt out at any time without affecting your account.',
  },
];

const sections = [
  {
    heading: '1. What are cookies?',
    body: 'Cookies are small text files placed on your device when you visit a website. We also use similar technologies such as local storage, pixels, and SDKs in our mobile apps. Throughout this policy we refer to all of these as "cookies" for simplicity.',
  },
  {
    heading: '2. How we use cookies',
    body: 'We use cookies to keep you signed in, secure the service, remember your preferences, measure how the product is used, and — with your consent where required — to deliver relevant marketing.',
  },
  {
    heading: '3. Managing cookies',
    body: 'You can control non-essential cookies via the cookie banner shown on your first visit, or through your browser settings at any time. Blocking strictly necessary cookies may prevent you from using parts of Keskedo.',
  },
  {
    heading: '4. Third-party cookies',
    body: 'Some cookies are set by third-party providers, such as analytics or fraud-prevention services, acting on our behalf. These providers are bound by contract to use the data only for the purposes we specify.',
  },
  {
    heading: '5. Updates',
    body: 'We may update this Cookie Policy as our practices change. The "Last updated" date at the top of this page shows the most recent version.',
  },
];

export const Cookies = () => {
  return (
    <MarketingLayout
      title="Cookie Policy"
      subtitle="Last updated: 2026-04-01. This policy explains how Keskedo uses cookies and similar technologies."
    >
      <article className="space-y-12">
        <div className="space-y-8">
          {sections.map((s, i) => (
            <section key={i} className="space-y-3">
              <h2 className="text-xl font-bold text-slate-900">{s.heading}</h2>
              <p className="text-slate-600 leading-relaxed">{s.body}</p>
            </section>
          ))}
        </div>

        <section className="space-y-4">
          <h2 className="text-xl font-bold text-slate-900">Categories of cookies we use</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {cookieTypes.map((t, i) => (
              <div key={i} className="p-6 bg-slate-50 border border-slate-200 rounded-2xl space-y-2">
                <h3 className="font-bold text-slate-900">{t.name}</h3>
                <p className="text-sm text-slate-600 leading-relaxed">{t.desc}</p>
              </div>
            ))}
          </div>
        </section>
      </article>
    </MarketingLayout>
  );
};
